import React from 'react';

import { H1 } from '../PageBuilder/Primitives/Heading';
import SectionBuilder from '../PageBuilder/SectionBuilder/SectionBuilder';

/**
 * Content-only terms of service for modals (AuthenticationPage, etc.).
 * Static SectionBuilder import avoids async chunk failures on auth routes.
 */
const TermsOfServiceContent = props => {
  const { inProgress, error, data, featuredListings } = props;

  const hasContent = data => typeof data?.content === 'string';
  const exposeContentAsChildren = data => {
    return hasContent(data) ? { children: data.content } : {};
  };

  if (inProgress || error || !data) {
    return null;
  }

  const CustomHeading1 = props => <H1 as="h2" {...props} />;

  return (
    <SectionBuilder
      {...data}
      options={{
        featuredListings,
        fieldComponents: {
          heading1: { component: CustomHeading1, pickValidProps: exposeContentAsChildren },
        },
        isInsideContainer: true,
      }}
    />
  );
};

export default TermsOfServiceContent;
